/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_StorageInputs */



/**
* | output |
* | --- |
* | "Storage add-on" |
*
* @param {Partner_Add_Customer_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_storage = /** @type {((inputs?: Partner_Add_Customer_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicher-Add-on")
	return /** @type {LocalizedString} */ ("Storage add-on")
});